import { ReactNode, useState } from "react";
import { Layout } from "./Layout";
import { Home, Building2, Calendar, DollarSign, Settings, ChevronDown, X, Menu } from "lucide-react";
import { useLocation, Link } from "wouter";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Sidebar } from "@/components/layout/Sidebar";
import logo from '@/assets/staymiddle-logo.png';

interface OwnerLayoutProps {
  children: ReactNode;
}

export default function OwnerLayout({ children }: OwnerLayoutProps) {
  const [location] = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const navItems = [
    { label: "Dashboard", href: "/owner/dashboard", icon: <Home className="w-5 h-5 mr-2" />, active: location === "/owner/dashboard" },
    { label: "My Properties", href: "/owner/properties", icon: <Building2 className="w-5 h-5 mr-2" />, active: location === "/owner/properties" },
    { label: "Bookings", href: "/owner/bookings", icon: <Calendar className="w-5 h-5 mr-2" />, active: location === "/owner/bookings" },
    { label: "Earnings", href: "/owner/earnings", icon: <DollarSign className="w-5 h-5 mr-2" />, active: location === "/owner/earnings" },
    { label: "Settings", href: "/settings", icon: <Settings className="w-5 h-5 mr-2" />, active: location === "/owner/settings" },
  ];

  return (
    <div className="flex min-h-screen">
      <Sidebar navItems={navItems} collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>{children}</Layout>
    </div>
  );
} 